import { makeStyles, createStyles } from "@mui/styles"
import { Theme } from "@mui/material"

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginTop: "5rem",
      textAlign: "center"
    }
  })
);
